// stores/useMainContentTab.jsx
import { create } from "zustand";

const useMainContentTab = create((set) => ({
    mainContentTab: "StartScreen",
    setMainContentTab: (tab) => set({ mainContentTab: tab }),
}));
export default useMainContentTab;
